import { render, staticRenderFns } from "./AttachmentSelectionTable.vue?vue&type=template&id=aa8e3d42&scoped=true&"
import script from "./AttachmentSelectionTable.vue?vue&type=script&lang=ts&"
export * from "./AttachmentSelectionTable.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentSelectionTable.vue?vue&type=style&index=0&id=aa8e3d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e3d42",
  null
  
)

export default component.exports